import { useBrand } from "../context/BrandContext";

export default function StaffBrand({ onNavigate }) {
  const { logos } = useBrand();
  const logo = logos?.app || (typeof window !== "undefined" ? localStorage.getItem("brandLogoAppUrl") : null) || "/logo.jpg";
  return <a href="/" className="staff-brand" onClick={onNavigate}>
    <img src={logo} alt="Alkeya Mobile" width="52" height="52" loading="eager" decoding="async" />
    <span className="staff-wordmark" aria-hidden="true">alkeya<span>.</span></span>
  </a>;
}
